import { Grid } from "@mui/material";
import { useStyles } from "./instruction-banner-style";
import { useTranslation } from "react-i18next";
import { RenderHTML } from "components/sanitizeHtml/sanitizeHtml";

export const InstructionBanner  = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid className={`${classes.gridContainer} instruction-banner`.trim()}>
      <RenderHTML content={t("basket_reminder_message")} />
    </Grid>
  );
};
